import axios from 'axios';

import type { IApiOptions } from './types';

// TODO: configure axios instance
export const api = async <TRESULT, TDATA = unknown>(url: string, options?: IApiOptions<TDATA>): Promise<TRESULT> => {
  try {
    const result = await axios({
      url,
      method: options?.method || 'GET',
      data: options?.data,
      ...options,
    });

    return result.data as TRESULT;
  } catch (error) {
    // TODO: update error handling
    if (axios.isAxiosError(error)) {
      throw new Error(error.response?.data?.toString() || error.message);
    }

    throw new Error(error instanceof Error ? error.message : String(error));
  }
};
